export default {
  loggedIn() { return !!localStorage.getItem("token") },
  logIn(user, token) {
    localStorage.setItem("storageUser", JSON.stringify(user))
    localStorage.setItem("token", token)
  },
  logOut() {
    localStorage.removeItem("storageUser")
    localStorage.removeItem("token")
    localStorage.removeItem("userRoutes")
  },
  getUser() {
    const u = localStorage.getItem("storageUser")
    return u ? JSON.parse(u) : null
  },
  /**
   * 获取用户路由权限列表
   */
  getUserRoutes() {
    const r = localStorage.getItem('userRoutes')
    return r ? JSON.parse(r) : null
  },
  /**
   * 检查用户是否有某个路由的访问权限
   * @param {string} path 路由路径，如 '/clue'
   * @returns {boolean} true=有权限或无需权限控制，false=无权限
   */
  hasRoutePermission(path) {
    // 公开路由始终可访问
    const publicPaths = ['/home', '/login', '/bill', '/custom-service', '/kefu', '/no-permission']
    if (publicPaths.includes(path)) return true
    const routes = this.getUserRoutes()
    // 没有路由数据，除公开路由外禁止访问
    if (!routes || !Array.isArray(routes) || routes.length === 0) return false
    // isPublic=true的路由始终可访问
    if (routes.some(r => r.isPublic === true && r.path === path)) return true
    // 检查用户路由列表中是否包含该路径
    return routes.some(r => r.path === path)
  }
}
